import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip'
import clsx from 'clsx'
import { Button } from '../components/ui/button'
import { SparklesIcon, XIcon } from 'lucide-react'
import { getCurrentDirection } from '@/i18n/config'
import { useTranslation } from '@/i18n'

type AIChatButtonProps = {
  onClick: () => void
  isOpen: boolean
}

const AiChatButton = ({ onClick, isOpen }: AIChatButtonProps) => {
  const { t } = useTranslation()
  const isRTL = getCurrentDirection() === 'rtl'

  return (
    <TooltipProvider>
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          onClick={onClick}
          variant="icon"
          className={clsx(
            "w-10 h-10 absolute bottom-10 flex items-center justify-center z-[999]",
            isRTL ? 'left-4' : 'right-4'
          )}
        >
          {isOpen ? (
            <XIcon className="text-white w-6" />
          ) : (
            <SparklesIcon className="text-white w-6" />
          )}
        </Button>
      </TooltipTrigger>
      <TooltipContent side={isRTL ? 'right' : 'left'}>
        <p>{isOpen ? t('chat:buttons.close_chat') : t('chat:buttons.open_chat')}</p>
      </TooltipContent>
    </Tooltip>
  </TooltipProvider>
  )
}

export default AiChatButton
